import { TOGGLE_OPTIONAL_RENDER } from './constants';
/** https://redux.js.org/recipes/reducingboilerplate#generating-reducers */
export const createReducer = (initialState, handlers) => {
    return (state = initialState, action) => {
        // eslint-disable-next-line no-prototype-builtins
        if (handlers.hasOwnProperty(action.type)) {
            return handlers[action.type](state, action);
        }
        return state;
    };
};
export const baseReduceHandler = (state, action) => ({ ...state, ...action });
export const reducer = createReducer({}, {
    [TOGGLE_OPTIONAL_RENDER]: baseReduceHandler,
});
//# sourceMappingURL=reducer.js.map